import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ApiService } from "../../services/api.service";

import { FileSystemFileEntry, UploadEvent, UploadFile } from "ngx-file-drop";
import { ModalAlertaAvisoComponent } from '../modal-alerta-aviso/modal-alerta-aviso.component';


@Component({
  selector: "app-modal-valida-csv",
  templateUrl: "./modal-valida-csv.component.html",
  styleUrls: ["./modal-valida-csv.component.scss"],
})
export class ModalValidaCsvComponent implements OnInit {
  @Input() corPrimaria: string;
  @Output() fecharModal = new EventEmitter();

  uf = ""
  municipio = ""
  downloadData = ""
  portfolio = ""
  hash = ""

  arquivo: any;
  hoje = new Date();
  uploadIcon = true;
  validado = false;
  files: UploadFile[] = [];
  formValido = false;
  arquivoValido = false;
  showModalAvisoAlerta = false;
  conteudoAviso = 'É necessário selecionar um arquivo CSV para prosseguir.';
  tituloAviso = 'Atenção!';
  showDropdown = false;
  hashArquivoVazio = "6a74b271ea49339a37aace814b67f89b5af6bb8d076d8a4f0e21b424f80b2a70";

  limpaForm() {
    this.uf = null;
    this.municipio = null;
    this.downloadData = null;
    this.arquivo = null;
    this.portfolio = null;
    this.formValido = false;
    this.arquivoValido = false;
    this.hash = null;
    this.uploadIcon = true;
  }

  dropped(event: UploadEvent) {
    const droppedFile: any = event.files[0];

    try {
      if (
        droppedFile.fileEntry.isFile &&
        droppedFile.relativePath.endsWith(".csv")
      ) {
        const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
        fileEntry.file((file: File) => {
          this.uploadIcon = false;
          this.validado = true;
          this.arquivo = file;
          this.clickEventIcon();
          this.arquivo = file;
        });
      } else {
        this.files = [];
        this.uploadIcon = true;
        this.validado = false;
      }
    } catch (error) {
      if (droppedFile.name.endsWith(".csv")) {
        this.validado = true;
        this.uploadIcon = false;
        this.arquivo = droppedFile;
      } else {
        this.uploadIcon = true;
        this.validado = false;
      }
    }
  }

  inputFile(event: any) {
    document.getElementById("fileInput").click();
  }
  removeFile() {
    this.uploadIcon = true;
    this.validado = false;
    this.arquivo = null;
    console.log("Arquivo removido?", this.arquivo);

  }
  constructor(private ApiService: ApiService) { }

  ngOnInit() { }

  fechar() {
    this.fecharModal.emit();
  }

  async fazNada() {
    console.log('Fazendo nada');
  }

  async validarCsv() {
    let response = null;
    this.hash = null;

    if ((this.arquivo && this.arquivo.name.endsWith(".csv"))) {
      this.hash = await this.gerarHashArquivo(this.arquivo);
      console.log('hash', this.hash);

      if (this.hash === this.hashArquivoVazio) {
        this.formValido = true;
        this.arquivoValido = false;
        return false;
      }

      response = await this.ApiService.arquivo(this.hash);
      console.log('response', response);

      this.formValido = true;

    } else {
      this.showModalAvisoAlerta = true;
      this.formValido = false;
      return false;
    }

    if (response.content.length === 0) { return this.arquivoValido = false; }

    if (this.hash === response.content[0].hash) {
      this.arquivoValido = true;
    } else {
      this.arquivoValido = false;
    }

    const retorno = response.content[0];
    this.downloadData = retorno.strData;
    const referencia = retorno.referencia;
    this.portfolio = referencia.split(":")[0].trim();
    if (referencia.includes("/")) {
      this.municipio = referencia.split(":")[1].split("/")[0].trim();
      this.uf = referencia.split("/")[1].trim();
    } else {
      this.municipio = 'Não especificado.';
      this.uf = referencia.split(":")[1].trim();
    }
  }

  clickEventIcon() {
    const botao = document.querySelector('#buttonVlidate') as HTMLElement;
    botao.click();
  }

  async gerarHashArquivo(file: File): Promise<any> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = () => {
        const arrayBuffer = reader.result as ArrayBuffer;
        const buffer = new Uint8Array(arrayBuffer);
        window.crypto.subtle.digest('SHA-256', buffer).then(hashBuffer => {
          const hashArray = Array.from(new Uint8Array(hashBuffer));
          const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
          resolve(hashHex);
        });
      };

      reader.onerror = () => reject("Erro ao ler o arquivo");

      reader.readAsArrayBuffer(file);
    });
  }

  fecharModalAvisoAlerta(data) {
    this.showModalAvisoAlerta = false;
    this.conteudoAviso = 'É necessário selecionar um arquivo CSV para prosseguir.';
  }
}



// WEBPACK FOOTER //
// ./src/app/components/modal-valida-csv/modal-valida-csv.component.ts